exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-analytics-collection-analytics-styles__topRow {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 24px;\n  border-bottom: 0;\n}\n\n.src-analytics-collection-analytics-styles__controls {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n\n.src-analytics-collection-analytics-styles__loader {\n  display: flex;\n  justify-content: center;\n  margin: 60px auto;\n}\n\n.src-analytics-collection-analytics-styles__loader span {\n  width: 30px;\n  height: 30px;\n}\n", ""]);

// exports
exports.locals = {
	"topRow": "src-analytics-collection-analytics-styles__topRow",
	"controls": "src-analytics-collection-analytics-styles__controls",
	"loader": "src-analytics-collection-analytics-styles__loader"
};